import { MessageContentTypeEnum } from '../message';

export type AttachmentItemTypes = MessageContentTypeEnum;
export const AttachmentItemTypes = MessageContentTypeEnum;
export type AttachmentMenuIcons = 'music' | 'file' | 'image';

export interface AttachmentItem {
  file: File;
  path: string;
  type?: AttachmentItemTypes;
  sortOrder: number;
}

export interface AttachmentItems {
  attachments: AttachmentItem[];
  caption?: string;
  type?: AttachmentItemTypes;
}
